/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Base_ColourInputs */

const en_reference_field_base_colour = /** @type {(inputs: Reference_Field_Base_ColourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base colour`)
};

/**
* | output |
* | --- |
* | "Base colour" |
*
* @param {Reference_Field_Base_ColourInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_base_colour = /** @type {((inputs?: Reference_Field_Base_ColourInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Base_ColourInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_base_colour(inputs)
});